import React, { useEffect } from 'react';
import './KayakingHome.css';

const heroImage = 'https://images.unsplash.com/photo-1689841667551-eeaee48f2247?auto=format&fit=crop&fm=jpg&q=78&w=2200';

const reviews = [
  {
    name: 'Samuel Yanez',
    text: 'A true masterclass in survival! Kevin went above and beyond by demonstrating how to nearly drown with grace. We learned a lot about kayaking - and even more about staying calm.',
  },
  {
    name: 'Rachael Westwood',
    text: 'Fun experience - 100% recommend! Speaking as a repeat customer, this is the freshest fleet of kayaks, best snacks, and most helpful advice you will find on the river.',
  },
  {
    name: 'Amanda Thai',
    text: 'Felt totally safe the whole time, definitely not dangerous!!!',
  },
  {
    name: 'Sam Thompson',
    text: 'Did not get injured and could theoretically run a marathon.',
  },
];

const tripTypes = [
  {
    title: 'Day Trips',
    body: 'A clean, simple American River outing with gear, launch planning, snacks, and practical paddling advice handled by Kevin.',
  },
  {
    title: 'Weekend Trips',
    body: 'A longer river weekend for groups who want more time outside, more snacks, and a little more story value when Monday comes around.',
  },
  {
    title: 'Gear Included',
    body: 'Kayaks, paddles, life jackets, dry bags, and the essentials are ready to go. You bring water, sun protection, and a good attitude.',
  },
];

export default function KayakingHome() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Kevin's Kayaking Club | American River Trips";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="kayaking-home">
      <section className="kayak-hero" style={{ backgroundImage: `linear-gradient(90deg, rgba(5, 16, 13, 0.88), rgba(5, 16, 13, 0.38)), url(${heroImage})` }}>
        <header className="kayak-header">
          <a className="kayak-brand" href="/kayaking">
            <span>Kevin's Kayaking Club</span>
          </a>
          <nav className="kayak-nav" aria-label="Kevin's Kayaking Club navigation">
            <a href="#trips">Trips</a>
            <a href="#reviews">Reviews</a>
            <a href="mailto:contact@howyoumet.us">Contact</a>
          </nav>
        </header>

        <div className="kayak-hero-content">
          <p className="kayak-eyebrow">American River kayak trips</p>
          <h1>Kevin's Kayaking Club</h1>
          <p className="kayak-hero-copy">
            Day trips and weekend river trips with the gear, planning, snacks, and steady guidance your group needs for a memorable paddle.
          </p>
          <div className="kayak-hero-actions">
            <a className="kayak-primary-action" href="mailto:contact@howyoumet.us?subject=Kevin%27s%20Kayaking%20Club%20Trip">
              Book a trip
            </a>
            <a className="kayak-secondary-action" href="#reviews">
              Read reviews
            </a>
          </div>
        </div>

        <div className="kayak-hero-rating" aria-label="Google rating">
          <strong>5.0</strong>
          <span>4 Google reviews</span>
        </div>
      </section>

      <section className="kayak-section kayak-intro" aria-label="Trip overview">
        <div>
          <p className="kayak-eyebrow">Built for groups</p>
          <h2>Everything is handled before you hit the water.</h2>
        </div>
        <p>
          Kevin offers American River trips for people who want the outdoor adventure without turning logistics into a second job. The club provides the river gear, helps plan the day, and keeps the tone calm, practical, and fun.
        </p>
      </section>

      <section id="trips" className="kayak-section kayak-trip-grid" aria-label="Trip options">
        {tripTypes.map((trip) => (
          <article key={trip.title} className="kayak-trip-card">
            <h3>{trip.title}</h3>
            <p>{trip.body}</p>
          </article>
        ))}
      </section>

      <section className="kayak-section kayak-details" aria-label="What is included">
        <div className="kayak-detail-media" role="img" aria-label="Kayakers preparing for river rapids" style={{ backgroundImage: `url(${heroImage})` }} />
        <div className="kayak-detail-copy">
          <p className="kayak-eyebrow">What to expect</p>
          <h2>Professional planning, river-day energy.</h2>
          <ul>
            <li>American River day and weekend trip options.</li>
            <li>Kayaks, paddles, life jackets, dry storage, and group gear.</li>
            <li>Snacks, launch coordination, and practical advice before and during the trip.</li>
            <li>A relaxed pace that keeps the day fun without losing sight of safety.</li>
          </ul>
        </div>
      </section>

      <section id="reviews" className="kayak-section kayak-reviews" aria-label="Google reviews">
        <div className="kayak-section-heading">
          <p className="kayak-eyebrow">Google reviews</p>
          <h2>Rated 5.0 by paddlers with excellent survival instincts.</h2>
        </div>
        <div className="kayak-review-grid">
          {reviews.map((review) => (
            <article key={review.name} className="kayak-review-card">
              <div className="kayak-stars" aria-label="5 star review">★★★★★</div>
              <p>{review.text}</p>
              <strong>{review.name}</strong>
            </article>
          ))}
        </div>
      </section>

      <section className="kayak-section kayak-contact" aria-label="Contact Kevin's Kayaking Club">
        <div>
          <p className="kayak-eyebrow">Plan your trip</p>
          <h2>Ready for the American River?</h2>
          <p>Email Kevin with your group size, ideal dates, and whether you want a day trip or weekend trip.</p>
        </div>
        <a className="kayak-primary-action" href="mailto:contact@howyoumet.us?subject=Kevin%27s%20Kayaking%20Club%20Trip">
          contact@howyoumet.us
        </a>
      </section>
    </main>
  );
}
